import React from 'react';

const Toolbar = () => {
    return (
        <div style={{marginTop: 60}}/>
    );
};

export default Toolbar;
